import React, { useEffect, useState } from "react";
import dashboardStyle from "../styles/Dashboard.module.css";
import { useDataContext } from "../contexts/AuthContext";
import { useDebtsContext } from "../contexts/FeeContext";
import {
  getPaymentMethodsByOrderId,
  storePayments,
  getExpirationDate,
  getPaymentInformation,
} from "../services/api";
import "../styles/estilos/modaldos.css";
import logoPng from "../images/Frame.png";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const PAYMENT_METHOD_DESCRIPTIONS = {
  "Depósito Bancario":
    "Realizás un depósito en la cuenta bancaria de Little Blue. Luego informás el comprobante desde el dashboard.",
  Efectivo:
    "Pagás en efectivo a tu asesor/a en los días acordados. Ideal si preferís no usar medios digitales.",
  "Transferencia Bancaria":
    "Transferís desde tu homebanking o billetera virtual para que podamos registrar el pago en el pedido.",
  PagoFácil:
    "Pagás en cualquier sucursal de PagoFácil usando el código que te genera el sistema.",
  "Tarjeta de crédito":
    "Elegí la opción de cuotas que más te sirva para cerrar el pedido.",
  "GO CUOTAS":
    "Podés financiar el pedido desde la opción de débito/cuotas disponible para este grupo.",
};

const Modal2 = ({
  onAcceptClick,
  onBackClick,
  setPaymentInformation,
  setPaymentMethod,
  setTotal,
  setPaid,
  vengodelModal1,
  handleAtrasClick,
  vengodelModal2,
  isBlockedByApprovedSizes = false,
}) => {
  const { contextData, checkCustomerAlive } = useDataContext();
  const { setUserDebts } = useDebtsContext();
  const navigate = useNavigate();
  const [paymentMethods, setPaymentMethods] = useState({});
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [selectedInstallments, setSelectedInstallments] = useState({});
  const [expandedMethods, setExpandedMethods] = useState({});
  const [loading, setLoading] = useState(true);
  const [expirationDate, setExpirationDate] = useState(null);
  const [isCloseButtonEnabled, setIsCloseButtonEnabled] = useState(false);
  const [submitButtonBlocked, setSubmitButtonBlocked] = useState(false);

  useEffect(() => {
    if (!isBlockedByApprovedSizes) {
      return;
    }

    Swal.fire({
      icon: "info",
      iconColor: "#d54ab7",
      confirmButtonColor: "#0071ce",
      title: "Atención",
      text: "No podés seleccionar método de pago porque hay prendas con talles aprobados.",
    }).then(() => {
      if (typeof onBackClick === "function") {
        onBackClick();
      }
    });
  }, [isBlockedByApprovedSizes, onBackClick]);

  useEffect(() => {
    if (isBlockedByApprovedSizes) {
      return;
    }
    if (!contextData || !contextData.customer || !contextData.customer.id) {
      return;
    }
    getPaymentInformation(contextData.customer.id, contextData.customer.order_id)
      .then((data) => {
        setPaymentMethod(data.payment_method);
        // Habilitar el botón de cierre si payment_method tiene un valor
        if (data.payment_method) {
          setIsCloseButtonEnabled(true);
        } else {
          setIsCloseButtonEnabled(false);
        }
      })
      .catch((error) => {
        console.error("Error al obtener la información de pago:", error);
      });
  }, [contextData.customer.id, contextData.customer.order_id, isBlockedByApprovedSizes]);

  useEffect(() => {
    if (isBlockedByApprovedSizes) {
      return;
    }
    if (
      !contextData ||
      !contextData.customer ||
      !contextData.customer.lead_id
    ) {
      return;
    }

    const fetchPaymentMethods = async () => {
      try {
        const isAlive = await checkCustomerAlive(contextData.customer.id);
        if (!isAlive) {
          Swal.fire({
            icon: "warning",
            iconColor: "#d54ab7",
            confirmButtonColor: "#0071ce",
            title: "Atencion",
            text: "Tu cuenta ha sido desactivada. Por favor, contacta a tu representante para más información.",
          }).then(() => {
            navigate("/");
          });
          return;
        }
        const data = await getPaymentMethodsByOrderId(
          contextData.customer.order_id
        );
        if (typeof data === "object" && !Array.isArray(data)) {
          setPaymentMethods(data);
          setLoading(false);
        } else {
          console.log(
            "La respuesta del servidor no contiene un objeto de métodos de pago."
          );
        }
      } catch (error) {
        console.log(
          `Error en la solicitud de métodos de pago: ${error.message}`
        );
      }
    };
    fetchPaymentMethods();
  }, [contextData.customer.lead_id, isBlockedByApprovedSizes]);

  useEffect(() => {
    if (isBlockedByApprovedSizes) {
      return;
    }
    if (
      !contextData ||
      !contextData.customer ||
      !contextData.customer.order_id
    ) {
      return;
    }

    const fetchExpirationDate = async () => {
      try {
        const data = await getExpirationDate(contextData.customer.order_id);
        setExpirationDate(data.expirationDate);
      } catch (error) {
        console.log(`Error fetching expiration date: ${error.message}`);
      }
    };
    fetchExpirationDate();
  }, [contextData.customer.order_id, isBlockedByApprovedSizes]);
  // Función para verificar si la fecha de expiración ha pasado
  const isExpired = (dateStr) => {
    if (!dateStr) return false; // Si no hay fecha, no está expirada

    // Reemplazar el espacio con 'T' para convertir a formato ISO 8601
    const isoDateStr = dateStr.replace(" ", "T");
    const expDate = new Date(isoDateStr);
    const today = new Date();

    // Establecer las horas a 0 para comparar solo fechas
    today.setHours(0, 0, 0, 0);
    expDate.setHours(0, 0, 0, 0);

    return expDate < today;
  };

  // Función para formatear la fecha al formato dd/mm/yy
  const formatDate = (dateStr) => {
    if (!dateStr) return "Fecha no disponible";

    // Reemplazar el espacio con 'T' para convertir a formato ISO 8601
    const isoDateStr = dateStr.replace(" ", "T");
    const date = new Date(isoDateStr);

    if (isNaN(date)) return "Fecha inválida";

    let dia = date.getDate();
    let mes = date.getMonth() + 1; // Los meses van de 0 a 11
    let año = date.getFullYear().toString().slice(-2); // Obtener los últimos dos dígitos

    // Asegurarse de que el día y el mes tengan dos dígitos
    dia = dia < 10 ? "0" + dia : dia;
    mes = mes < 10 ? "0" + mes : mes;

    return `${dia}/${mes}/${año}`;
  };

  const handleMethodChange = (method) => {
    setSelectedMethod(method.payment_selection_id);
    setSelectedInstallments({
      [method.paymentMethod]: method.cuotas,
    });
  };

  const handleToggleExpansion = (index) => {
    setExpandedMethods({
      ...expandedMethods,
      [index]: !expandedMethods[index],
    });
  };

  const handleSingleInstallmentSelect = (method) => {
    setSelectedMethod(method.payment_selection_id);
    setSelectedInstallments({
      [method.paymentMethod]: method.cuotas,
    });
  };

  const handleSecondModalSubmit = async (e) => {
    e.preventDefault();
    setSubmitButtonBlocked(true);
    
    try {
      const data = await storePayments(
        contextData.customer.id,
        selectedMethod,
        contextData.customer.order_id
      );
      setUserDebts(data.accountSummary);
      setPaymentInformation(data.paymentInformation);
      setPaymentMethod(data.paymentInformation.payment_method);
      setTotal(data.paymentInformation.total);
      setPaid(data.paymentInformation.paid);
      vengodelModal2(false);
      onAcceptClick();
    } catch (error) {
      console.error(
        `Error en la petición de almacenar pagos: ${error.message}`
      );
      // 409 = la cuenta está cerrada (ya pagó, o sus prendas entraron en producción).
      // Decir "seleccione un método de pago" ahí sería mentirle: eligió bien, lo que no
      // puede es cambiarla a esta altura.
      const cerrada = error?.status === 409;
      Swal.fire({
        icon: "warning",
        iconColor: "#d54ab7",
        confirmButtonColor: "#0071ce",
        title: "Atencion",
        text: cerrada
          ? error?.serverMessage ||
            "No podés cambiar tu forma de pago: ya registraste un pago o tus prendas entraron en producción."
          : "Por favor seleccione un metodo de pago.",
      });
    } finally {
      setSubmitButtonBlocked(false);
    }
  };

  return (
    <>
      {isBlockedByApprovedSizes ? null : (
      <>
      {loading ? (
        <div className="contcargando">
          <img src={logoPng} alt="littleBlueLogo" className="imgcargando" />
          <h2 className="text-muted">CARGANDO...</h2>
          <div className="loader"></div>
        </div>
      ) : (
        <div className={dashboardStyle.modalBackground}>
          <div className={dashboardStyle.modal}>
            <form onSubmit={handleSecondModalSubmit}>
              <div className={dashboardStyle.modalHeader}>
                {vengodelModal1 ? (
                  <button
                    type="button"
                    className={dashboardStyle.modalBackBtn}
                    onClick={handleAtrasClick}
                  >
                    <span aria-hidden="true">←</span> Volver
                  </button>
                ) : null}
                <span className={dashboardStyle.modalStep}>Paso 2 de 2</span>
                <h2 className={dashboardStyle.modalTitle}>
                  Métodos <span className={dashboardStyle.modalTitleAccent}>de</span> Pago
                </h2>
                <p className={dashboardStyle.modalSubtitle}>
                  Es importante que elijas la manera correcta, para que podamos
                  calcular bien el importe.
                </p>
              </div>

              <div className={dashboardStyle.modalMethodList}>
                {Object.keys(paymentMethods).map((methodName, index) => {
                  // Ordenar las cuotas de menor a mayor (el catálogo puede venir desordenado).
                  const methodGroup = [...paymentMethods[methodName]].sort(
                    (a, b) => Number(a.cuotas) - Number(b.cuotas)
                  );
                  const hasSingleInstallment =
                    methodGroup.length === 1 && methodGroup[0].cuotas === 1;
                  const isExpanded = Boolean(expandedMethods[index]);
                  const isSelected = methodGroup.some(
                    (method) => selectedMethod === method.payment_selection_id
                  );
                  const description =
                    PAYMENT_METHOD_DESCRIPTIONS[methodName] || "";

                  const handleHeaderClick = () => {
                    if (hasSingleInstallment) {
                      handleSingleInstallmentSelect(methodGroup[0]);
                    }
                    handleToggleExpansion(index);
                  };

                  return (
                    <div
                      key={index}
                      className={`${dashboardStyle.modalMethodRow} ${
                        isSelected ? dashboardStyle.modalMethodSelected : ""
                      }`}
                    >
                      <button
                        type="button"
                        className={dashboardStyle.modalMethodHeader}
                        onClick={handleHeaderClick}
                      >
                        <span className={dashboardStyle.modalRadio}>
                          {isSelected ? (
                            <span className={dashboardStyle.modalRadioFilled} />
                          ) : null}
                        </span>
                        <span className={dashboardStyle.modalMethodLabel}>
                          {methodName}
                        </span>
                        <span className={dashboardStyle.modalMethodChevron}>
                          {isExpanded ? "▲" : "▼"}
                        </span>
                      </button>

                      {isExpanded ? (
                        <div className={dashboardStyle.modalMethodBody}>
                          {description ? (
                            <p className={dashboardStyle.modalMethodDesc}>
                              {description}
                            </p>
                          ) : null}

                          {hasSingleInstallment ? (
                            methodGroup[0].adicional !== "none" &&
                            methodGroup[0].porcentaje > 0 ? (
                              <div className={dashboardStyle.modalInstallmentList}>
                                <div className={dashboardStyle.modalInstallmentOption}>
                                  <span className={dashboardStyle.modalInstallmentMeta}>
                                    {methodGroup[0].adicional === "discount" &&
                                    !isExpired(expirationDate)
                                      ? `Descuento: ${methodGroup[0].porcentaje}% - Vence: ${formatDate(expirationDate)}`
                                      : null}
                                    {methodGroup[0].adicional === "surcharge"
                                      ? `Recargo: ${methodGroup[0].porcentaje}%`
                                      : null}
                                  </span>
                                </div>
                              </div>
                            ) : null
                          ) : (
                            <div className={dashboardStyle.modalInstallmentList}>
                              {methodGroup.map((method, innerIndex) => (
                                <label
                                  key={innerIndex}
                                  className={dashboardStyle.modalInstallmentOption}
                                  htmlFor={`radio-${index}-${innerIndex}`}
                                >
                                  <input
                                    type="radio"
                                    id={`radio-${index}-${innerIndex}`}
                                    name="paymentMethod"
                                    checked={
                                      selectedMethod === method.payment_selection_id &&
                                      selectedInstallments[method.paymentMethod] ===
                                        method.cuotas
                                    }
                                    onChange={() => handleMethodChange(method, index)}
                                  />
                                  <span>
                                    {method.paymentMethod} {method.cuotas} cuotas
                                  </span>
                                  <span className={dashboardStyle.modalInstallmentMeta}>
                                    {method.adicional === "discount" &&
                                    !isExpired(expirationDate)
                                      ? `Descuento: ${method.porcentaje}% - Vence: ${formatDate(expirationDate)}`
                                      : null}
                                    {method.adicional === "surcharge"
                                      ? `Recargo: ${method.porcentaje}%`
                                      : null}
                                  </span>
                                </label>
                              ))}
                            </div>
                          )}
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>

              <div className={dashboardStyle.modalFooter}>
                <button
                  type="button"
                  className={dashboardStyle.btnOutline}
                  onClick={onBackClick}
                  disabled={!isCloseButtonEnabled && !vengodelModal1}
                >
                  Cerrar
                </button>
                <button
                  className={dashboardStyle.btnPrimary}
                  type="submit"
                  disabled={submitButtonBlocked || !selectedMethod}
                >
                  {submitButtonBlocked ? "Procesando..." : "Aceptar"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      </>
      )}
    </>
  );
};

export default Modal2;
